/* eslint-disable */
import React, { useEffect } from "react";

import "ds/Core/src/tokens.css";

import "./BrokenHeartIcon.css";

export const BrokenHeartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 328 328"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    id="broken_heart_container"
  >
    <path
      d="M103.129,22.3342l.37.4815L87.5518,35.2924c-4.0938,3.203-4.0938,9.3984.0001,12.6014l7.8937,6.1761c4.0939,3.203,4.0939,9.3984,0,12.6014l-7.8938,6.176c-4.0938,3.203-4.0938,9.3984.0001,12.6014l7.8937,6.176c4.0939,3.203,4.0939,9.3983,0,12.6013l-7.8938,6.176c-4.0938,3.203-4.0938,9.399.0001,12.602l7.8937,6.176c4.0939,3.203,4.0939,9.398,0,12.601l-7.8937,6.176c-4.0939,3.203-4.0939,9.398,0,12.601l15.9471,12.477c-17.4092.139-34.6783-7.556-46.1035-22.327L11.8924,91.854C-7.44812,66.8419,-2.69725,31.0007,22.4955,11.8071C47.6883,-7.39471,83.7884,-2.67791,103.129,22.3342Z"
      transform="translate(60.750729 77.48146)"
      id="broken_heart_left"
    />
    <path
      d="M103.37,22.3342l-.37.4815L87.0531,35.2924c-4.0938,3.203-4.0938,9.3984,0,12.6014l7.8938,6.1761c4.0939,3.203,4.0939,9.3984,0,12.6014l-7.8938,6.176c-4.0938,3.203-4.0938,9.3984,0,12.6014l7.8938,6.176c4.0939,3.203,4.0939,9.3983,0,12.6013l-7.8938,6.176c-4.0938,3.203-4.0938,9.399,0,12.602l7.8938,6.176c4.0938,3.203,4.0939,9.398,0,12.601l-7.8938,6.176c-4.0938,3.203-4.0938,9.398,0,12.601L103,173.035c17.409.139,34.678-7.556,46.103-22.327l45.503-58.854c19.341-25.0121,14.59-60.8533-10.603-80.0469C158.81,-7.39471,122.71,-2.67791,103.37,22.3342Z"
      transform="translate(60.750729 77.48146)"
      id="broken_heart_right"
    />
  </svg>
);
